/**
 * 角色选择
 * @author 3173
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool } from '@/tool';
import { modelUtils } from "../../../../utils";
let { WizContainer } = framework_tool;
let { WizTag, WizTableTransfer, WizTooltip, WizSpin } = component_tool;
let { $$,checkStrLength } = utils_tool;
/**
 * 左边表格columns
 */
const leftTableColumns = [
  {
    dataIndex: 'title',
    title: '角色名称',
    width:100,
    ellipsis:true,
    render: (text) => <WizTooltip title={text} placement="topLeft" >{text}</WizTooltip>,
  },
  {
    dataIndex: 'code',
    title: '角色编码',
    width:100,
    ellipsis:true,
    render: (text) => <WizTooltip title={text} placement="topLeft" >{text}</WizTooltip>,
  },
  {
    dataIndex: 'remark',
    title: '角色描述',
    width:100,
    ellipsis:true,
    render: (text) => <WizTooltip title={text} placement="topLeft" >{text}</WizTooltip>,
  },
];

/**
 * 右边表格columns
 */
const rightTableColumns = [
  {
    dataIndex: 'title',
    title: '角色名称',
    width:100,
    ellipsis:true,
    render: (text) => <WizTooltip title={text} placement="topLeft" >{text}</WizTooltip>,
  },
  {
    dataIndex: 'code',
    title: '角色编码',
    width:100,
    ellipsis:true,
    render: (text) => <WizTooltip title={text} placement="topLeft" >{text}</WizTooltip>,
  }
];

class RoleSelect extends WizContainer {

  componentName = 'RoleSelect';

  constructor(props) {
    super(props);
    this.state = {
      targetKeys: [],
      mockData: []
    }
  }

  /**返回给主页面数据 */
  _selectRoles = () => {
    const { targetKeys, mockData } = this.state;
    let rolse = [];
    targetKeys.forEach(targetKey => {
      mockData.forEach(data => {
        if (data.key === targetKey) {
          rolse.push({roleId:targetKey, roleName: data.title })
        }
      });
    });
    if(this.props.roleSelect){
      this.props.roleSelect(rolse);
      this.setState({targetKeys:[]})
    }
  };

  onChange = nextTargetKeys => {
    this.setState({ targetKeys: nextTargetKeys });
  };

  _componentDidMount = () => {
    this._getData();
  };

  propsAndStateOnChange = {
    roleList: this._setMockData.bind(this),
  }

  _setMockData(nextProps, nextState) {
    let mockData = [];
    nextProps.roleList && nextProps.roleList.forEach(data => {
      let dis = false;
      if(this.props.selectedIds && this.props.selectedIds.indexOf(data.id)!=-1){
        dis = true;
      }
      mockData.push({
        key: data.id,
        title: data.name,
        code: data.code,
        remark: data.remark,
        disabled: dis,
      })
    });
    nextState.mockData = mockData;
    return true;
  }


  _getData() {
    this.doAction({
      path: "role/getListByCondition",
      payload: {
        key: "roleGetListByConditionKey"+this.props.menuId,
        apiParams: {}
      }
    });
  }


  _render() {
    const { targetKeys } = this.state;
    let mockData = [];
    this.props.roleList && this.props.roleList.forEach(data => {
      let dis = false;
      if(this.props.selectedIds && this.props.selectedIds.indexOf(data.id)!=-1){
        dis = true;
      }
      mockData.push({
        key: data.id,
        title: data.name,
        code: data.code,
        remark: data.remark,
        disabled: dis,
      })
    });
    let returnView = null;

    returnView = <WizTableTransfer
      key={this.props.menuId}
      dataSource={mockData}
      targetKeys={targetKeys}
      onChange={this.onChange}
      filterOption={(inputValue, item) =>
        item.title.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1 || item.code.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1 || item.remark.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
      }
      leftColumns={leftTableColumns}
      rightColumns={rightTableColumns}
    />

    return <WizSpin tip={'加载中'} spinning={this.props.roleLoading}> {returnView} </WizSpin>
  }
}

const mapStateToProps = (state, ownProps) => {
  const { role } = state;
  const roleList = modelUtils.getModelEntity(role, "roleGetListByConditionKey"+ownProps.menuId);
  const load = modelUtils.getLoadingState(state, ['role']);
  return {
    roleList: roleList.data,
    ...load
  }
};

const options = { withRef: true };

export default connect(mapStateToProps, null, null, options)(RoleSelect);

